import { EntityMetric } from '@/lib/enums';

const MetricProperty = Object.freeze({
  [EntityMetric.ACTIVITIES]: {
    label: {
      singular: 'Activity',
      plural: 'Activities',
    },
  },
  [EntityMetric.ACTIVITY_BUDGET]: {
    label: {
      singular: 'Activity Cost (Role Hours)',
      plural: 'Activities Cost (Role Hours)',
    },
    formatOptions: {
      style: 'currency',
      currency: 'USD',
      notation: 'compact',
      compactDisplay: 'short',
    },
  },
  [EntityMetric.ACTIVITY_BUDGET_PERCENTAGE]: {
    label: {
      singular: '% Activity Cost (Role Hours)',
      plural: '% Activity Cost (Role Hours)',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.ACTIVITY_BUDGET_PERCENTAGE_OF_DESIGN]: {
    label: {
      short: '% Design Cost (Role Hours)',
      singular: '% of Design Cost (Role Hours)',
      plural: '% of Design Cost (Role Hours)',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.ACTIVITY_BUDGET_PERCENTAGE_OF_GROUP]: {
    label: {
      short: '% Team Cost (Role Hours)',
      singular: '% of Connected Team (Role Hours)',
      plural: '% of Connected Team (Role Hours)',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.ACTIVITY_BUDGET_PERCENTAGE_OF_PARENT]: {
    label: {
      short: '% Parent Cost (Role Hours)',
      singular: '% of Connected Parent (Role Hours)',
      plural: '% of Connected Parent (Role Hours)',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.ACTIVITY_BUDGET_PERCENTAGE_OF_ROLE]: {
    label: {
      short: '% Role Cost (Role Hours)',
      singular: '% of Connected Role (Role Hours)',
      plural: '% of Connected Role (Role Hours)',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.ACTIVITY_BUDGET_PERCENTAGE_OF_TOTAL]: {
    label: {
      short: '% Visible Cost (Role Hours)',
      singular: '% of Total Visible (Role Hours)',
      plural: '% of Total Visible (Role Hours)',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.ASSIGNED]: {
    label: {
      singular: 'Reassigned',
      plural: 'Reassigned',
    },
  },
  [EntityMetric.AVERAGE_BUDGET]: {
    label: {
      short: 'Av. Budget',
      singular: 'Average budget',
      plural: 'Average budget',
    },
    formatOptions: {
      style: 'currency',
      currency: 'USD',
      notation: 'compact',
      compactDisplay: 'short',
    },
  },
  [EntityMetric.AVERAGE_ACTIVITY_BUDGET]: {
    label: {
      short: 'Av. Cost (Role Hours)',
      singular: 'Average Activity Cost (Role Hours)',
      plural: 'Average Activity Cost (Role Hours)',
    },
    formatOptions: {
      style: 'currency',
      currency: 'USD',
      notation: 'compact',
      compactDisplay: 'short',
    },
  },
  [EntityMetric.AVERAGE_ACTIVITY_BUDGET_PERCENTAGE]: {
    label: {
      short: 'Av. Cost % (Role Hours)',
      singular: 'Average Activity Cost % (Role Hours)',
      plural: 'Average Activity Cost % (Role Hours)',
    },
    formatOptions: {
      style: 'currency',
      currency: 'USD',
      notation: 'compact',
      compactDisplay: 'short',
    },
  },
  [EntityMetric.AVERAGE_BUDGET_PERCENTAGE]: {
    label: {
      short: 'Av. Budget %',
      singular: 'Average budget %',
      plural: 'Average budget %',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.AVERAGE_COST]: {
    label: {
      short: 'Av. Cost (Role FTE)',
      singular: 'Average Activity Cost (Role FTE)',
      plural: 'Average Activity Cost (Role FTE)',
    },
    formatOptions: {
      style: 'currency',
      currency: 'USD',
      notation: 'compact',
      compactDisplay: 'short',
    },
  },
  [EntityMetric.AVERAGE_COST_PERCENTAGE]: {
    label: {
      short: 'Av. Cost % (Role FTE)',
      singular: 'Average Activity Cost % (Role FTE)',
      plural: 'Average Activity Cost % (Role FTE)',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.AVERAGE_FTE]: {
    label: {
      short: 'Av. FTE',
      singular: 'Average FTE',
      plural: 'Average FTE',
    },
    formatOptions: {
      style: 'decimal',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.AVERAGE_FTE_PERCENTAGE]: {
    label: {
      short: 'Av. FTE %',
      singular: 'Average FTE %',
      plural: 'Average FTE %',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.AVERAGE_HOURS]: {
    label: {
      short: 'Av. Hours',
      singular: 'Average hours',
      plural: 'Average hours',
    },
    formatOptions: {
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.AVERAGE_HOURS_PERCENTAGE]: {
    label: {
      short: 'Av. Hours %',
      singular: 'Average hours %',
      plural: 'Average hours %',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.AVERAGE_SPAN]: {
    label: {
      short: 'Av. Span',
      singular: 'Average span',
      plural: 'Average span',
    },
    formatOptions: {
      style: 'decimal',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.BUDGET]: {
    label: {
      singular: 'Budget',
      plural: 'Budget',
    },
    formatOptions: {
      style: 'currency',
      currency: 'USD',
      notation: 'compact',
      compactDisplay: 'short',
    },
  },
  [EntityMetric.BUDGET_PERCENTAGE]: {
    label: {
      singular: 'Budget %',
      plural: 'Budget %',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.BUDGET_PERCENTAGE_OF_DESIGN]: {
    label: {
      short: '% Design Budget',
      singular: '% of Design Budget',
      plural: '% of Design Budget',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.BUDGET_PERCENTAGE_OF_GROUP]: {
    label: {
      short: '% Team Budget',
      singular: '% of Connected Team Budgets',
      plural: '% of Connected Team Budgets',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.BUDGET_PERCENTAGE_OF_PARENT]: {
    label: {
      short: '% Parent Budget',
      singular: '% of Connected Parent Budgets',
      plural: '% of Connected Parent Budgets',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.BUDGET_PERCENTAGE_OF_ROLE]: {
    label: {
      short: '% Role Budget',
      singular: '% of Connected Role Budgets',
      plural: '% of Connected Role Budgets',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.BUDGET_PERCENTAGE_OF_TOTAL]: {
    label: {
      short: '% Visible Budget',
      singular: '% of Total Visible Budgets',
      plural: '% of Total Visible Budgets',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.COST]: {
    label: {
      singular: 'Activity Cost (Role FTE)',
      plural: 'Activity Cost (Role FTE)',
    },
    formatOptions: {
      style: 'currency',
      currency: 'USD',
      notation: 'compact',
      compactDisplay: 'short',
    },
  },
  [EntityMetric.COST_PERCENTAGE]: {
    label: {
      singular: '% Activity Cost (Role FTE)',
      plural: '% Activity Cost (Role FTE)',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.COST_PERCENTAGE_OF_DESIGN]: {
    label: {
      short: '% Design Cost (Role FTE)',
      singular: '% of Design Cost (Role FTE)',
      plural: '% of Design Cost (Role FTE)',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.COST_PERCENTAGE_OF_GROUP]: {
    label: {
      short: '% Team Cost (Role FTE)',
      singular: '% of Connected Team (Role FTE)',
      plural: '% of Connected Team (Role FTE)',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.COST_PERCENTAGE_OF_PARENT]: {
    label: {
      short: '% Parent Cost (Role FTE)',
      singular: '% of Connected Parent (Role FTE)',
      plural: '% of Connected Parent (Role FTE)',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.COST_PERCENTAGE_OF_ROLE]: {
    label: {
      short: '% Role Cost (Role FTE)',
      singular: '% of Connected Role (Role FTE)',
      plural: '% of Connected Role (Role FTE)',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.COST_PERCENTAGE_OF_TOTAL]: {
    label: {
      short: '% Visible Cost (Role FTE)',
      singular: '% Cost of Total Visible (Role FTE)',
      plural: '% Cost of Total Visible (Role FTE)',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.COUNT]: {
    label: {
      singular: 'Count',
      plural: 'Count',
    },
  },
  [EntityMetric.ENTITY_PERCENTAGE]: {
    label: {
      singular: '% of total team/role hours',
      plural: '% of total team/role hours',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.ALLOCATED_FTE]: {
    label: {
      singular: 'Allocated FTE',
      plural: 'Allocated FTE',
    },
    formatOptions: {
      style: 'decimal',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.FTE]: {
    label: {
      singular: 'FTE',
      plural: 'FTE',
    },
    formatOptions: {
      style: 'decimal',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.FTE_PERCENTAGE]: {
    label: {
      singular: '% FTE',
      plural: '% FTE',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.FTE_PERCENTAGE_OF_DESIGN]: {
    label: {
      short: '% Design FTE',
      singular: '% of Design FTE',
      plural: '% of Design FTE',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.FTE_PERCENTAGE_OF_GROUP]: {
    label: {
      short: '% Team FTE',
      singular: '% of Connected Team FTE',
      plural: '% of Connected Team FTE',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.FTE_PERCENTAGE_OF_PARENT]: {
    label: {
      short: '% Parent FTE',
      singular: '% of Connected Parent FTE',
      plural: '% of Connected Parent FTE',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.FTE_PERCENTAGE_OF_ROLE]: {
    label: {
      short: '% Role FTE',
      singular: '% of Connected Role FTE',
      plural: '% of Connected Role FTE',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.FTE_PERCENTAGE_OF_TOTAL]: {
    label: {
      short: '% Visible FTE',
      singular: '% of Total Visible FTE',
      plural: '% of Total Visible FTE',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.GROUPS]: {
    label: {
      singular: 'Team',
      plural: 'Teams',
    },
  },
  [EntityMetric.HOURS]: {
    label: {
      singular: 'Hour',
      plural: 'Hours',
    },
    formatOptions: {
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.HOURS_PERCENTAGE_OF_DESIGN]: {
    label: {
      short: '% Design Hours',
      singular: '% of Design Hours',
      plural: '% of Design Hours',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.HOURS_PERCENTAGE_OF_GROUP]: {
    label: {
      short: '% Team Hours',
      singular: '% of Connected Team Hours',
      plural: '% of Team Hours',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.HOURS_PERCENTAGE_OF_PARENT]: {
    label: {
      short: '% Parent Hours',
      singular: '% of Connected Parent Hours',
      plural: '% of Parent Hours',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.HOURS_PERCENTAGE_OF_ROLE]: {
    label: {
      short: '% Role Hours',
      singular: '% of Connected Role Hours',
      plural: '% of Role Hours',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.HOURS_PERCENTAGE_OF_TOTAL]: {
    label: {
      short: '% Visible Hours',
      singular: '% of Total Visible Hours',
      plural: '% of Total Visible Hours',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.HOURS_PERCENTAGE]: {
    label: {
      singular: '% Hours',
      plural: '% Hours',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.MANAGERS]: {
    label: {
      singular: 'Manager',
      plural: 'Managers',
    },
  },
  [EntityMetric.MOVED]: {
    label: {
      singular: 'Moved',
      plural: 'Moved',
    },
  },
  [EntityMetric.PERCENTAGE]: {
    label: {
      singular: 'Percentage',
      plural: 'Percentages',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.RELATIVE_PERCENTAGE]: {
    label: {
      singular: '% relative to parent in chart',
      plural: '% relative to parent in chart',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.OF_HOURS]: {
    label: {
      singular: 'Of hours',
      plural: 'Of hours',
    },
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
    },
  },
  [EntityMetric.ROLES]: {
    label: {
      singular: 'Role',
      plural: 'Roles',
    },
  },
  [EntityMetric.SPAN]: {
    label: {
      singular: 'Span',
      plural: 'Span',
    },
  },
});

export default MetricProperty;
